export const NURSES_QUERY_KEY_ROOT = "nurses";

/**
 * The cache entry `useRosterLookup` and HospitalDataProvider share. A standalone module so readers of the
 * cache (the error snackbar) don't import the query hooks and everything they pull in.
 */
export const departmentRosterQueryKey = (departmentId: string) => [NURSES_QUERY_KEY_ROOT, departmentId, undefined];
